import { render, staticRenderFns } from "./InventoryPage.vue?vue&type=template&id=7f5a97ed&scoped=true&"
import script from "./InventoryPage.vue?vue&type=script&lang=js&"
export * from "./InventoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5a97ed",
  null
  
)

export default component.exports